import currency from "currency.js";

export const parseFloatFormat = (value = 0, dec = 2) => {
  return currency(value, { precision: dec });
};

export const formatDateYmd = date => date.toISOString().slice(0, 10);
